import {
  Identifiable,
  Resource,
  Project,
  ProjectResource,
  CostProfile,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

function removeCostProfileAssignation(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/resources/${resource.uuid}`,
      method: HttpMethods.PATCH,
      data: { costProfile: null },
    });
}

export { removeCostProfileAssignation };
